import { Stack, styled } from '@mui/material';
import Image from 'next/image';
import Typography from '../Typography';
import { FC, useState } from 'react';

export type sortType = 'ascending' | 'descending';
export type Column = {
  title: string | JSX.Element;
  secondaryTitle?: string;
  span?: string;
  align?: string;
  padding?: string;
  sortKey?: string;
  onClick?: (props: { value: sortType; key: string }) => void;
};
const Column = styled(Stack)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.textColor.A30
}));

const SortMap: any = {
  1: 'ascending',
  2: 'descending'
};
const CustomColumn: FC<Column> = ({
  title,
  secondaryTitle,
  align,
  padding,
  sortKey,
  onClick
}) => {
  const [key, setKey] = useState<number>(1);
  const handleOnclick = () => {
    const newKey = key === 2 ? 1 : key + 1;
    setKey(newKey);
    onClick &&
      sortKey &&
      onClick({ value: SortMap[newKey] as sortType, key: sortKey });
  };
  const sortableColumn = !!sortKey;
  return (
    <Column
      {...(sortableColumn && {
        onClick: () => handleOnclick(),
        sx: {
          cursor: 'pointer',
          userSelect: 'none'
        }
      })}
      alignItems="center"
      gap={{ xs: 0, lg: 1 }}
      flexDirection={{ xs: 'column', lg: 'row' }}
      justifySelf={align ? align : 'center'}
      p={padding ? padding : 'center'}
    >
      <Stack flexDirection="row" alignItems="center" gap={{ xs: 0, lg: 1 }}>
        {sortableColumn && (
          <Image src="/assets/CaretUpDown.svg" alt="" width={16} height={16} />
        )}
        <div>{title}</div>
      </Stack>
      {secondaryTitle && (
        <Typography
          color="textColor.A60"
          variant="body3"
          alignSelf={{ xs: align, lg: 'center' }}
        >
          {secondaryTitle}
        </Typography>
      )}
    </Column>
  );
};

export default CustomColumn;
